
import { Component, Vue, Watch } from 'vue-property-decorator'
import ProductDetails from './components/product/ProductDetails.vue'
import Navigation from './components/navigation/Navigation.vue'
import Popover from './components/modals/Popover.vue'
import Notification from './components/common/Notification.vue'
import { ProductApiModel } from '@/interfaces/ProductApiModel'
import { namespace } from 'vuex-class'
import ProductRenderer from './components/product/ProductRenderer.vue'
import ConfirmModal from './components/modals/ConfirmModal.vue'
import { ConfirmModalData } from './interfaces/ConfirmModalData'
import { useOptionStore } from './store/modules/options'
import { Route } from 'vue-router/types/router'
const currentModel = namespace('currentModel')
const configurationSizes = namespace('configurationSizes')
const globalValues = namespace('globalValues')

@Component({
  components: {
    ProductDetails,
    Navigation,
    Popover,
    Notification,
    ProductRenderer,
    ConfirmModal
  }
})
export default class App extends Vue {
  private originalDebug?: (...data: any[]) => void
  public confirmModalVisible = false;
  public confirmModalData = new ConfirmModalData(undefined);

  mounted() {
    this.loadProduct()
    this.$root.$on('openConfirmModal', (data: ConfirmModalData) => this.openConfirmModal(data))
    window.enableDebug = this.enableDebug
    this.originalDebug = console.debug
    console.debug = data => { const unused = data }
  }

  public loadingApp = true

  public optionStore = useOptionStore();

  public loadProduct(): void {
    this.loadingApp = true
    this.loadModel(this.$route.params.productCode)
      .then((success) => {
        if (success) {
          return this.loadConfigurationSizes(this.model.code)
        } else {
          this.$router.push('/')
          this.$router.go(0)
          return Promise.resolve(false)
        }
      })
      .then(() => this.optionStore.loadOptions(this.model.code))
      .then(() => { this.loadingApp = false })
  }

  @currentModel.State
  public model!: ProductApiModel

  @currentModel.Action
  public loadModel!: (productCode: string) => Promise<boolean>

  @currentModel.Action
  public clearConfigurationKey!: () => void

  @configurationSizes.Action
  public loadConfigurationSizes!: (productCode: string) => Promise<boolean>

  @globalValues.Action
  public setNotification!: (message?: string) => void

  @Watch('$route')
  routeChanged(newRoute: Route, oldRoute: Route) {
    if (!newRoute?.params.productCode ||
      newRoute?.params.productCode !== oldRoute?.params.productCode) {
      if (window.configurationName) { delete window.configurationName }
      this.clearConfigurationKey()
      this.loadProduct()
    }
  }

  openConfirmModal(data: ConfirmModalData) {
    this.confirmModalData = data
    const modal = this.$refs['confirm-modal'] as ConfirmModal
    if (!modal) { return }
    modal.show()
  }

  enableDebug() {
    if (this.originalDebug) { console.debug = this.originalDebug }
    return 'ok'
  }
}
